export enum DraftType {
  TaskCode = 'TaskCode',
  FinancingOffer = 'FinancingOffer',
  Promotion = 'Promotion',
  PDF = 'PDF',
  MarketingCopy = 'MarketingCopy',
}
